import { render } from "./ViewParametrePage.vue?vue&type=template&id=834fd80c&ts=true"
import script from "./ViewParametrePage.vue?vue&type=script&lang=ts"
export * from "./ViewParametrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__